/**
 * 主题相关常量（架构 §8 共享知识）
 *  - THEME_STORAGE_KEY：localStorage 键，命名空间前缀防冲突。
 *  - ThemeMode：'light' | 'dark'，读写仅在 ThemeModeProvider。
 */
export type ThemeMode = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'zhihui:theme';
